<template>
  <div class="box">
    <div class="row p-3">
      <div class="col-md-12" style="text-align: right;">
        <router-link to="/templates/create" class="button p-3" v-if="userRole == 1">New Template</router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form @submit.stop.prevent="doSearch" class="box__header form--inline">
          <input v-model="quickSearch" type="search" placeholder="Quick search">
          <button class="button button--small" type="submit">Search</button>
        </form>
    
        <vdtnet-table
          ref="table"
          :fields="fields"
          :opts="options"
          @edit="doAlertEdit"
          @delete="doAlertDelete"
          >
        </vdtnet-table>
      </div>
    </div>
  </div>
</template>

<script>
import 'datatables.net'
import 'datatables.net-select'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'EmailTemplate',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    },
  },
  data() {
      return {
        options: {
          ajax: {
            url: this.$api + 'email-templates/table?nature=email',
            'headers': {
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
          },
          responsive: false,
          processing: true,
          searching: true,
          searchDelay: 1500,
          destroy: true,
          ordering: true,
          lengthChange: true,
          serverSide: true,
          dom: 'rtlip',
          autoWidth: false,
          lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
          pageLength: 25,
          columnDefs: [
            { targets: "_all", className: "text-wrap" } // custom class to wrap
          ],
        },
        fields: {
          template_name: { label: 'Title'},
          template_type: { 
            label: 'Type',
            render : (data, type, row) => {
              let content = "--"
              if(row.template_type == 1){
                content = "Admin Email"
              }else if(row.template_type == 2) {
                content = "System generated"
              }
              return content
            }
          },
          template_subject: { label: 'Subject' },
          actions: {
            sortable: false,
            label: ' ',
            render: (data, type, row) => {
              return `<a href="/templates/edit/${ row.template_id }" data-action="edit" class="icon icon--more">Edit</a>`
            }
          },
          delete: {
            sortable: false,
            label: ' ',
            className: 'table-action',
            render: (data, type, row) => {
              if (this.userRole == 1) {
                return `<a href="/email-templates/${ row.template_id }/delete" data-action="delete" class="icon icon--delete">Delete</a>`
              } else {
                return ''
              }
                
            }
          }
        },
        quickSearch: ''
      }
    },
    methods: {
      doSearch() {
        this.$refs.table.search(this.quickSearch)
      },
      doAlertEdit(data) {
        this.$router.push({ name: 'edit-template', params: { id: data.template_id }})
      },
      doAlertDelete(data) {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'email-templates/' + data.template_id + '/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.status) {
            this.$refs.table.reload()
            this.$notify({
              type: 'success',
              title: response.message
            });
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      },
    }
}
</script>

<style lang="scss" scoped>

</style>